import type { TableProps } from 'antd';
import { Breadcrumb, Button, Table } from 'antd';
import { FiPlus } from 'react-icons/fi';

import { Layout } from '../../components/layout';
import { TargetGroupDrawer } from './components';
import { BREADCRUMBS, TARGET_GROUPS_COLUMNS } from './TargetGroups.constants.tsx';
import type { TargetGroupsProps, TargetGroupType } from './TargetGroups.types.ts';

import './TargetGroups.styles.css';
import { useTranslation } from 'react-i18next';
import { Skeleton } from '../admin/components';
import { useEffect } from 'react';

export default function TargetGroups({
  groups,
  isLoading,
  openTargetGroupDrawer,
  onOpenTargetGroupDrawer,
  onCloseTargetGroupDrawer,
  onSubmitTargetGroup,
  setSelectedTargetGroupKeys,
  targetGroupId,
}: TargetGroupsProps) {
  const { t } = useTranslation();
  const rowSelection: TableProps<TargetGroupType>['rowSelection'] = {
    onChange: (selectedRowKeys: React.Key[]) => {
      setSelectedTargetGroupKeys(selectedRowKeys);
    },
  };

  useEffect(() => {
    document.title = `Administration ${t('pages.admin.module.target-groups')}`;
  }, [t]);

  return (
    <Layout>
      {isLoading ? (
        <Skeleton />
      ) : (
        <div className="admin-page">
          <Breadcrumb className="breadcrumb" items={BREADCRUMBS} />

          <div className="admin-page-bar">
            <h1 className="admin-page-bar--title">{t('pages.admin.module.target-groups')}</h1>
            <div className="admin-page-bar--actions">
              <Button
                icon={<FiPlus />}
                iconPosition="start"
                size="large"
                type="primary"
                onClick={(event) => onOpenTargetGroupDrawer(event, null)}
              >
                {t('common.add-new')}
              </Button>
            </div>
          </div>

          <Table<TargetGroupType>
            rowKey="id"
            rowSelection={{ type: 'checkbox', ...rowSelection }}
            columns={TARGET_GROUPS_COLUMNS}
            dataSource={groups}
            onRow={(record) => {
              return {
                onClick: (event: React.MouseEvent<HTMLButtonElement>) =>
                  onOpenTargetGroupDrawer(event, record?.id || null),
              };
            }}
          />

          {openTargetGroupDrawer && (
            <TargetGroupDrawer
              open={openTargetGroupDrawer}
              onClose={onCloseTargetGroupDrawer}
              onSubmit={onSubmitTargetGroup}
              targetGroupId={targetGroupId}
            />
          )}
        </div>
      )}
    </Layout>
  );
}
